import AppShell from '@/components/AppShell'
import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchLoads } from '@/lib/mockApi'
import type { LoadTicket } from '@/lib/types'
import Barcode from '@/components/Barcode'

export default function LoadDetail(){
  const { id } = useParams()
  const [loads, setLoads] = useState<LoadTicket[]>([])
  useEffect(()=>{ fetchLoads().then(setLoads) },[])
  const load = useMemo(()=> loads.find(l=>l.id===id), [loads, id])

  if (!load) return <AppShell title="Load Ticket"><div className="text-sm text-slate-600">Loading…</div></AppShell>

  const sec = load.securityTag || load.scaleNumber || load.id

  return (
    <AppShell title={`Load ${sec}`}>
      <div className="print-area grid gap-4">
        <div className="card">
          <div className="card-header">Ticket</div>
          <div className="card-body grid grid-cols-1 md:grid-cols-3 gap-3">
            <div><div className="text-xs text-slate-500">Security Tag / Scale #</div><div className="font-semibold">{sec}</div></div>
            <div><div className="text-xs text-slate-500">Status</div><div>{load.status||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Delivered</div><div>{load.deliveredAt||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Logger</div><div>{load.loggingCompany||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Trucking</div><div>{load.truckingCompany||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Driver</div><div>{load.driver||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Destination</div><div>{load.destination||'-'}</div></div>
            <div><div className="text-xs text-slate-500">Net Tons</div><div>{load.netTons ?? '-'}</div></div>
            <div><div className="text-xs text-slate-500">Gross Weight</div><div>{load.grossWeight ?? '-'}</div></div>

            {/* Container / Export */}
            <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-3">
              <Field label="Container #" value={load.containerNumber}/>
              <Field label="Seal #" value={load.sealNumber}/>
              <Field label="Container Type" value={load.containerType}/>
              <Field label="Shipping Line" value={load.line}/>
              <Field label="Voyage" value={load.voyage}/>
              <Field label="Port" value={load.port}/>
              <Field label="Tare Weight" value={load.tareWeight}/>
              <Field label="Fumigation" value={load.fumigationStatus}/>
            </div>

            <div className="md:col-span-3">
              <Barcode value={String(sec)} height={60} />
            </div>

            <div className="no-print">
              <button className="btn-secondary" onClick={()=>window.print()}>Print</button>
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  )
}

function Field({label,value}:{label:string; value:any}){
  return (
    <div>
      <div className="text-xs text-slate-500">{label}</div>
      <div>{value ?? '-'}</div>
    </div>
  )
}
